import React, { useEffect, useState } from 'react'
import { UserTokenURL } from '../../../services/ApiHIS';
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { postPrincipalProcedimientosIndividuales } from '../../../services/Contratacion';
import Loading from '../../Loading';
import ModalMaestroProcedimientos from './ModalMaestroProcedimientos';
import ModalModificarMaestroProcedimientos from './ModalModificarMaestroProcedimientos';
import ModalPerfilMP from './ModalPerfilMP';
import ModalServiciosPrestadosIPS from './ModalServiciosPrestadosIPS';
import ModalEliminarMaestroProcedimientoMP from './ModalEliminarMaestroProcedimientoMP';

const PrincipalProcedimientosIndividuales = () => {
    const [dataProcedimientos, setdataProcedimientos]=useState([])
    const [loading,setloading]=useState(true)
    const [modalOnMaestroProcedimientos, setmodalOnMaestroProcedimientos]=useState(false)
    const [modalOnModificarMaestroProcedimientos, setmodalOnModificarMaestroProcedimientos]=useState(false)
    const [modalOnServiciosPrestados , setmodalOnServiciosPrestados]=useState(false)
    const [modalOnPerfiles, setmodalOnPerfiles]=useState(false)
    const [modalOnEliminar , setmodalOnEliminar]=useState(false)
    const [selectCheckbosMaestroProcedimiento, setselectCheckbosMaestroProcedimiento]=useState(null)
    const [dataUnMaestroProcedimiento, setdataUnMaestroProcedimiento]=useState('')
    const [actualizarDataProcedimientos, setactualizarDataProcedimientos]=useState('')

  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    //token
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      //console.log(usuarioInfo, 'usuarioInfoStr confirmado')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])

  useEffect(()=>{
    setloading(false)
    setselectCheckbosMaestroProcedimiento('')
    postPrincipalProcedimientosIndividuales().then((res)=>{
        setloading(true)
        //console.log(res.data,'data procedimientos')
        setdataProcedimientos(res.data.data)
    })
  },[actualizarDataProcedimientos])

  const consultarProcedimientosIdividuales=(e)=>{
    e.preventDefault()
    const consultar={
        "PRCODI": e.target.codigo.value,
        "PrNomb":e.target.descripcion.value
    }
    setloading(false)
    postPrincipalProcedimientosIndividuales(consultar).then((res)=>{
        setloading(true)
        setdataProcedimientos(res.data.data)
    })
  }

  const handleOnclickCrear=()=>{
    setmodalOnMaestroProcedimientos(true)
  }

  const handleOnclickModificar =()=>{
    if(selectCheckbosMaestroProcedimiento){
      setmodalOnModificarMaestroProcedimientos(true)
    }
    
  }

  const handleCheboxMaestroProcedimientos=(item)=>{
    setselectCheckbosMaestroProcedimiento(item.PRCODI)
    setdataUnMaestroProcedimiento(item)
  }

  const handleOnclickPerfiles=()=>{
    if(selectCheckbosMaestroProcedimiento && (dataUnMaestroProcedimiento.PrIndPer === "S")){
      setmodalOnPerfiles(true)
    }
  }

  const handleClickServiciosPrestados=()=>{
    setmodalOnServiciosPrestados(true)
  }

  const handleOnclickDelete=()=>{
    if(selectCheckbosMaestroProcedimiento){
      setmodalOnEliminar(true)
    }
    
  }

  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Procedimientos Individuales
        </div>

        <form onSubmit={consultarProcedimientosIdividuales}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Codigo
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3 xl:w-96 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Descripción
              </label>
              <div className="flex">
                <input
                  name="descripcion"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form >
        <div className="flex ">
          
        <button
        onClick={handleOnclickCrear}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      <div className='px-2'>
      <button
                  onClick={handleOnclickModificar}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Modificar 
                </button>
      </div>
      {/* <div className='px-2'>
      <button
                
                  type="button"
                  className="inline-block px-6 py-1.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-yellow-700 hover:shadow-lg focus:bg-yellow-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Consultar
                </button>      
      </div> */}
      <div className='px-2'>
      <button
                  onClick={handleOnclickDelete}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Eliminar
                </button>
      </div>
      <div className='px-2'>
      <button
                  onClick={handleOnclickPerfiles}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Perfiles 
                </button>
      </div>
      <div className='px-2'>
      <button
                  onClick={handleClickServiciosPrestados}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Servicios Prestados 
                </button>
      </div>
      {/* <div className='px-2'>
        <button
            
            type="button"
            className="inline-block px-6 py-1.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out"
        >
            Excel
        </button>      
      </div> */}
      </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >                        
                      </th>                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Codigo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Estado?
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Perfil?
                      </th>  
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Paq.?
                      </th>                       
                    </tr>
                  </thead>
                  <tbody >
                  {loading ? (
                    dataProcedimientos.map((item,index)=>(                      
                      <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                        <div className="topping">
                        <input
                                  type="checkbox"
                                  checked={selectCheckbosMaestroProcedimiento === item.PRCODI}
                                  onChange={() => handleCheboxMaestroProcedimientos(item)}
                                />                          
                        </div>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                          {item.PRCODI}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                        {item.PrNomb}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">                            
                            <div className="topping">
                                    <input
                                        type="checkbox"
                                        checked={item.PrSta === 'S'}
                                    />                          
                            </div> 
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                            <div className="topping">
                                    <input
                                        type="checkbox"
                                        checked={item.PrIndPer === 'S'}
                                    />                          
                            </div>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                            <div className="topping">
                                    <input
                                        type="checkbox"
                                        checked={item.PrIndPaq === 'S'}
                                    />                          
                            </div>
                        </td>
                      </tr> 
                    ))                   
                  ) : (                    
                      <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <Loading /> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                  )}
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnMaestroProcedimientos? <ModalMaestroProcedimientos setmodalOnMaestroProcedimientos={setmodalOnMaestroProcedimientos} setactualizarDataProcedimientos={setactualizarDataProcedimientos}/>:null}
      {modalOnModificarMaestroProcedimientos? <ModalModificarMaestroProcedimientos setmodalOnModificarMaestroProcedimientos={setmodalOnModificarMaestroProcedimientos} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento} setactualizarDataProcedimientos={setactualizarDataProcedimientos}/>:null}
      {modalOnPerfiles? <ModalPerfilMP setmodalOnPerfiles={setmodalOnPerfiles} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento}/>:null}
      {modalOnServiciosPrestados? <ModalServiciosPrestadosIPS setmodalOnServiciosPrestados={setmodalOnServiciosPrestados}/>:null}
      {modalOnEliminar? <ModalEliminarMaestroProcedimientoMP setmodalOnEliminar={setmodalOnEliminar} dataUnMaestroProcedimiento={dataUnMaestroProcedimiento} setactualizarDataProcedimientos={setactualizarDataProcedimientos}/>:null}
    </>
  )
}

export default PrincipalProcedimientosIndividuales